import React, { useContext, useEffect } from "react";

import { useIdleTimer } from "react-idle-timer";
import { Navigate, Outlet } from "react-router-dom";

import PsContext from "../../context";
import Footer from "../../app/footer";
import { THEME_VARIANT } from "../../utils";

const StudentLayout = (props) => {
  const context = useContext(PsContext);

  const onIdle = () => {
    //context.logout();
  };

  const idleTimer = useIdleTimer({ onIdle, timeout: 1000 * 60 * 15 });

  useEffect(() => {
    context.loadSettings();
  }, []);

  if (context.logged != "yes") {
    return <Navigate to="/" />;
  } else {
    return (
      <div className={`ps_app_cls_${THEME_VARIANT}`}>
        <Outlet />
        <Footer />
      </div>
    );
  }
};
export default StudentLayout;
